import { toast } from 'react-toastify';
import { useAddOrganisation } from "../hooks/OrganisationHooks";
import { OrganisationDTO } from "../types/organisationDTO";
import ValidationSummary from "../ValidationSummary";
import OrganisationForm from "./OrganisationForm";
import { useState } from 'react';
import { ClipLoader } from 'react-spinners';
import { useTranslation } from 'react-i18next';

const OrganisationAdd = () => {
  const { t } = useTranslation();
  const createValidToDate = () => {
    const date = new Date();
    date.setFullYear(2099);
    date.setSeconds(0, 0);
    return date;
  };
  const [organisation, setOrganisation] = useState<OrganisationDTO>({
    id: "00000000-0000-0000-0000-000000000000",
    name: "",
    validFrom: new Date(new Date().setSeconds(0, 0)),
    validTo: createValidToDate(),
    lastModified: new Date(),
  });
  const addOrganisationMutation = useAddOrganisation(setOrganisation);

  return (
    <>
      {addOrganisationMutation.isError && (
        <ValidationSummary error={addOrganisationMutation.error} />
      )}
      {addOrganisationMutation.isPending ? (
        <div className="spinner-container" style={{ textAlign: 'center', marginTop: '20px' }}>
          <ClipLoader size={50} color={"#123abc"} loading={true} />
          <p>{t('organisation.addWait')}</p>
        </div>
      ) : (
        <OrganisationForm
          headerText="Add organisation"
          organisation={organisation}
          submitted={(organisation) => {
            addOrganisationMutation.mutate(organisation, {
              onSuccess: () => {
                toast.success(t('organisation.addSuccess'));
                history.back();
              },
              onError: () => {
                toast.error(t('organisation.addError'));
              }
            });
          }}
        />
      )}
    </>
  );
};

export default OrganisationAdd;
